import { render, staticRenderFns } from "./kolSelectCount.vue?vue&type=template&id=07961c64&scoped=true"
import script from "./kolSelectCount.vue?vue&type=script&lang=js"
export * from "./kolSelectCount.vue?vue&type=script&lang=js"
import style0 from "./kolSelectCount.vue?vue&type=style&index=0&id=07961c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07961c64",
  null
  
)

export default component.exports